import React from 'react';
import clsx from 'clsx';

import Button from '@common/Button';
import Container from '@common/Container';
import Section from '@common/Section';
import ImgColoredDropShadow from '@common/ImgColoredDropShadow';
import RichText from '@common/RichText';
import SmallTitle from '@common/SmallTitle';

import * as styles from './dropshadow.module.scss';

const DropShadow = ({ data }) => {
  const {
    title,
    showTitle,
    text,
    textAlignment,
    listClass,
    showImages,
    imagePosition,
    imagePositionTop,
    imageWidth,
    imageMaxHeight,
    imageNegativeMargin,
    buttons,
    images,
    video,
    topMargin,
    bottomMargin,
    bgColour,
    bgNoPadding,
    bgFullwidth
  } = data;
  return (
    <Section style={{ marginTop: `calc(${imageNegativeMargin} + 50px)` }} spacing={clsx(topMargin, bottomMargin ? bottomMargin : 'mb-7')} className={clsx({
        'container card': !bgFullwidth,
        [styles.removeTopMargin]: imageNegativeMargin && !imagePositionTop
      })}>
      <Container>
        <div className={`position-relative col-12`}>
          {images.map(image => (
            <ImgColoredDropShadow key={image.id} image={image} colour={bgColour} direction={imagePosition}/> 
          ))}
          <div className={clsx(`bg-white p-3 py-lg-5`, styles.headingBox, imageWidth)} style={{
            right: imagePosition === 'Left' ? 0 : null,
            left: imagePosition === 'Right' ? 0 : null,
            borderTopLeftRadius: imagePosition === 'Left' ? 10 : 0,
            borderBottomLeftRadius: imagePosition === 'Left' ? 10 : 0,
            borderTopRightRadius: imagePosition === 'Right' ? 10 : 0,
            borderBottomRightRadius: imagePosition === 'Right' ? 10 : 0,
          }}>
            {(text || buttons) &&
              <div className={clsx({
                  'text-center': textAlignment === 'Center',
                  'text-end': textAlignment === 'Right',
                })}>
                {(showTitle && title) &&
                  <SmallTitle>{title}</SmallTitle>
                }
                {text &&
                  <RichText
                    json={text}
                    h2='mb-3'
                    li='py-2'
                    a='fs-16'
                    ul={listClass}
                  />
                }
                {buttons && 
                  <div className={clsx('d-flex flex-column flex-sm-row justify-content-center', {
                    'mb-3': imagePosition === 'Center',
                    'justify-content-lg-start ms-lg-n1': images && imagePosition !== 'Center',
                    })}>
                    {buttons.map(button => (
                      <Button
                        key={button.id}
                        to={button.link}
                        variant={button.variant}
                        size={button.size}
                        addClass={clsx('scale-1 mb-2 m-sm-1', button.class)}
                        copy={button.copy}
                        icon={button.icon}
                        iconSize={button.iconSize}
                        iconPosition={button.iconPosition}
                        modal={button.modal}
                      />
                    ))}
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </Container>
    </Section>
  )
}

export default DropShadow
